import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';
import { baSvgIcons } from '../../app.svg.icons';

@Directive({ selector: '[baSvgicon]' })

export class SvgIconsDirective implements OnInit {
    icons = baSvgIcons;
    @Input('baSvgicon') icon: string;

    constructor(public el: ElementRef,
        public renderer: Renderer2) { }

    ngOnInit() {
        this.createSVG();
    }

    createSVG(): void {
        this.renderer.setProperty(this.el.nativeElement, 'innerHTML', this.icons[this.icon]);
    }

}
